
import React from 'react';
import { Button } from '@/components/ui/button';
import { Globe } from 'lucide-react';

interface LanguageToggleProps {
  currentLang: string;
  onToggle: (lang: string) => void;
}

const LanguageToggle = ({ currentLang, onToggle }: LanguageToggleProps) => {
  return (
    <Button
      variant="outline"
      size="sm"
      onClick={() => onToggle(currentLang === 'ar' ? 'en' : 'ar')}
      className="flex items-center gap-2"
    >
      <Globe className="h-4 w-4" />
      {currentLang === 'ar' ? 'English' : 'العربية'}
    </Button>
  );
};

export default LanguageToggle;
